var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M10.5,2.5a8,8,0,1,0,8,8A8.007,8.007,0,0,0,10.5,2.5Zm0,12.851a.859.859,0,1,1,.859-.859A.852.852,0,0,1,10.5,15.351Zm.842-4.413a.271.271,0,0,0-.152.253v.859a.674.674,0,1,1-1.347,0v-.859a1.62,1.62,0,0,1,1.095-1.549,1.347,1.347,0,0,0,.909-1.533,1.352,1.352,0,0,0-2.189-.792,1.331,1.331,0,0,0-.505,1.044.674.674,0,1,1-1.347,0,2.691,2.691,0,0,1,.96-2.072A2.64,2.64,0,0,1,10.988,5.7a2.709,2.709,0,0,1,.354,5.238Z",
    transform: "translate(-2.5 -2.5)",
    fill: "#aeaeae"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.32b2671423f1d1f76a7a5e1db0c4651f.svg";
export { ForwardRef as ReactComponent };